import { EventCategoryName, EventName } from "core-lib/types/Events";
import trackEventV2 from "core-lib/utils/eventsV2";

export const trackCtaClicked = ({
  option,
  section,
  pageName = "",
  category = EventCategoryName.Fuel,
  popupName = "",
  position = null,
  roCode = null,
  additionalAttributes = {},
}: {
  option: string;
  section?: string;
  pageName?: string;
  category?: EventCategoryName;
  popupName?: string;
  position?: number;
  roCode?: string;
  additionalAttributes?: any;
}) => {
  trackEventV2(EventName.CtaClicked, {
    ctaName: option,
    sectionName: section,
    popupName,
    category,
    pageName,
    position,
    ...(roCode ? { ro_code: roCode } : {}),
    ...additionalAttributes,
  });
};
export const trackCardClicked = ({
  option,
  pageName = "",
  category = EventCategoryName.Fuel,
  section = "",
  popupName = "",
  additionalAttributes = {},
}: {
  option: string;
  section?: string;
  pageName?: string;
  category?: EventCategoryName;
  popupName?: string;
  additionalAttributes?: any;
}) => {
  trackEventV2(EventName.CardClicked, {
    ctaName: option,
    cardName: option,
    sectionName: section,
    popupName,
    category,
    pageName,
    ...additionalAttributes,
  });
};
export const trackPopUpViewed = ({
  popupName,
  pageName = "",
  category = EventCategoryName.Fuel,
  additionalAttributes = {},
}: {
  popupName?: string;
  pageName?: string;
  category?: EventCategoryName;
  additionalAttributes?: any;
}) => {
  trackEventV2(EventName.PopupViewed, {
    popupName,
    category,
    pageName,
    ...additionalAttributes,
  });
};
export const trackWidgetViewed = ({
  pageName = "",
  section = "",
  category = EventCategoryName.Fuel,
  option = "",
}: {
  pageName?: string;
  section?: string;
  category?: EventCategoryName;
  option?: string;
}) => {
  trackEventV2(EventName.SectionViewed, {
    sectionName: section,
    category,
    pageName,
    ...(option ? { option_selected: option, selected_option: option } : {}),
  });
};
export const trackWidgetClicked = ({
  pageName = "",
  category = EventCategoryName.Fuel,
  section = "",
  option,
  additionalAttributes = {},
}: {
  pageName: string;
  category?: EventCategoryName;
  section?: string;
  option?: string;
  additionalAttributes?: any;
}) => {
  trackEventV2(EventName.CardClicked, {
    cardName: option,
    ctaName: option,
    sectionName: section,
    category,
    pageName,
    ...additionalAttributes,
  });
};

export const trackPageLoad = ({
  pageName = "",
  category = EventCategoryName.Fuel,
  tabName = "",
  additionalAttr = {},
}: {
  pageName: string;
  category?: EventCategoryName;
  additionalAttr?: any;
  tabName?: string;
}) => {
  trackEventV2(EventName.PageLoaded, {
    category,
    pageName,
    tabName,
    ...additionalAttr,
  });
};

export const trackCardViewed = ({
  option,
  pageName = "",
  category = EventCategoryName.Fuel,
  section = "",
  popupName = "",
  additionalAttr = {},
}: {
  option: string;
  section?: string;
  pageName?: string;
  category?: EventCategoryName;
  popupName?: string;
  additionalAttr?: any;
}) => {
  trackEventV2(EventName.CardViewed, {
    cardName: option,
    ctaName: option,
    sectionName: section,
    category,
    pageName,
    popupName,
    ...additionalAttr,
  });
};
